import script from "./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=019dba52&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019dba52"]])

export default __exports__